import {useEffect, useEffectEvent} from 'react'

// This hook is used to detect when there is a clicks outside of the given elements.
// params:
// - refs: an array of refs to check for clicks outside
// - callback: a callback to call when there is a click outside of the refs
export function useClickOutside(refs: Array<React.RefObject<HTMLElement | null>>, callback: () => void) {
  const onClick = useEffectEvent((e: MouseEvent) => {
    if (!document.body.contains(e.target as Node)) {
      return
    }
    // If the clicked element isn't inside the refs, call the callback
    if (!refs.some(ref => ref.current?.contains(e.target as Node))) {
      callback()
    }
  })

  useEffect(() => {
    window.addEventListener('click', onClick, true)

    return () => {
      window.removeEventListener('click', onClick, true)
    }
  }, [])
}
